import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverBraillerCatalogApi {
    static getBraillerCatalogResources(searchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(searchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getBraillerCatalogItem(id: string) {
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog/${id}`,
                requestTypes.GET,
            ),
        );
    }

    static getAllBraillerCatalogItems() {
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog/all`,
                requestTypes.GET,
            ),
        );
    }

    static deleteBraillerCatalogItem(id: string) {
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog/${id}`,
                requestTypes.DELETE,
                null,
                apiConstants.successMessage.brailler.CATALOG_ITEM_DELETED,
            ),
        );
    }

    static addBraillerCatalogItemWithInventory(catalogItemWithInventory: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog`,
                requestTypes.POST,
                JSON.stringify(catalogItemWithInventory),
                apiConstants.successMessage.brailler.CATALOG_ITEM_ADDED,
            ),
        );
    }

    static updateBraillerCatalogItemWithInventory(catalogItemWithInventory: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + `braillers/catalog`,
                requestTypes.PUT,
                JSON.stringify(catalogItemWithInventory),
                apiConstants.successMessage.brailler.CATALOG_ITEM_UPDATED,
            ),
        );
    }
}

export const braillerCatalogApi = config.environment.MODE === config.modes.SERVER ? serverBraillerCatalogApi : serverBraillerCatalogApi;